import { pageTitle } from "../PageTitle";

import HeaderOne from "../Header/HeaderOne";
import videoSource from "../../assets/videos/SiW_AI_Search_Engine.mp4";
import videoSource1 from "../../assets/videos/sor_demo.mp4";
import FooterOne from "../Footer/FooterOne";
import SorBanner from "./../../assets/images/banner/sor-banner.png";


const Sor = () => {
  pageTitle("SOR System");

  return (
    <>
      <HeaderOne></HeaderOne>

      <div
        className="ai-overlay-wrapper"
        style={{ backgroundImage: `url(${SorBanner})` }}
      >
        {/* <img src={SorBanner} alt="AI Operations" className="main" /> */}

        <div className="ai-overlay">
          {/* Centered text */}
          <div className="ai-overlay-center-project-text">
            <h2 className="ai-overlay-project">
              AI-Powered SOR Search Engine{" "}
            </h2>
            <p>Fast Item code & rate search </p>
          </div>
        </div>
      </div>

      <section className="siw-rpa-section">
        <div className="siw-rpa-container-data-engineering container">
          <div className="siw-rpa-content">
            {/* <span className="siw-rpa-tag">
              Still Manually Searching item codes & rates in SOR (Schedule of
              Rates) documents?
            </span> */}

            <div className="siw-rpa-text">
              <p>
                The Smart iLab Works <span className="SiW">(SiW)</span>{" "}
                AI-Powered SOR Search Engine is a specialized tool designed to
                automate the retrieval of item codes and rates from Schedule of
                Rates (SOR) documents. This technology addresses the
                inefficiencies of manual searching, which often slows down
                project submissions and increases administrative burdens.
              </p>
            </div>

            <div className="siw-rpa-desc">
              <h3 className="pb-2">Key Capabilities</h3>
              <p>
                The AI search engine goes beyond simple data retrieval by
                integrating into broader business workflows:
              </p>
              <p
                className="py-2"
                style={{ fontWeight: "bold", color: "#009999" }}
              >
                The Three-Step Workflow{" "}
              </p>
              <ol>
                <li>
                  Automated Search: It quickly identifies specific item codes
                  and rates across various SOR documents.
                </li>
                <li>
                  Software Integration: It can automate quote generation
                  directly within accounting software.
                </li>
                <li>
                  Workflow Automation: The system supports approval email
                  workflows, further reducing manual intervention.
                </li>
              </ol>
            </div>
          </div>

          <div className="col-md-5 col-12">
            <div className="siw-project-video-wrapper">
              <video className="siw-project-video" controls>
                <source src={videoSource1} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
            {/* <h4 style={{ color: "rgb(230, 233, 55)" }}>Free Trial Available</h4>
            <p>
              <span style={{ fontSize: "20px", fontWeight: "bold" }}>SiW</span>{" "}
              is currently offering a free trial session. <br />
              Our team will create a dedicated AI-powered app.
            </p>
            <p className="siw-project-website-text-top">
              To explore more about the{" "}
              <strong>AI-powered SOR Search Engine</strong>, Click 👉{" "}
              <a
                href="https://sor.siw.sg/"
                target="_blank"
                rel="noopener noreferrer"
                className="siw-project-website-link blinking1"
              >
                SOR Search Engine
              </a>
              .
            </p>
            <a href="/contact" className="siw-rpa-btn">
              <i className="bi bi-calendar-week btn-icon"></i>
              Start a Free Trial
            </a> */}
          </div>
        </div>
      </section>
      <div
        className="container"
        style={{ marginTop: "-10px", marginBottom: "30px" }}
      >
        <div className="siw-rpa-desc mt-4 mt-md-0">
          <h3>Business Benefits</h3>
          <p className="pt-2 ">
            By implementing this AI-powered solution, companies can eliminate
            manual steps that typically delay orders and tender timelines. This
            leads to faster submissions and a more streamlined administrative
            process
          </p>
        </div>
      </div>
      {/* <section className="siw-project-section">
        <div className="siw-project-container container">
          <div className="row g-4 align-items-start">
            <div className="col-md-6 mt-3">
              <h3 className="siw-project-heading">Introducing SOR</h3>

              <div className="siw-project-video-wrapper">
                <video className="siw-project-video" controls>
                  <source src={videoSource} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>

            <div className="col-md-6 mt-3">
              <h3 className="siw-project-heading">Watch a Demo Video</h3>

              <div className="siw-project-video-wrapper">
                <video className="siw-project-video" controls>
                  <source src={videoSource1} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>
          </div>
          <p className="siw-project-website-text">
            To explore more about the{" "}
            <strong>AI-powered SOR Search Engine</strong>, Click 👉{" "}
            <a
              href="https://sor.siw.sg/"
              target="_blank"
              rel="noopener noreferrer"
              className="siw-project-website-link blinking"
            >
              SOR Search Engine
            </a>
            .
          </p>
        </div>
      </section> */}
      <FooterOne></FooterOne>
    </>
  );
};
export default Sor;
